import modular from 'modujs';
import * as modules from './modules';
import globals from './globals';
import { $html, $body } from './utils/dom';
import { ENV, CSS_CLASS, CUSTOM_EVENT } from './config'
import gsap from "gsap";

const app = new modular({
    modules,
});

function init() {
    globals();

    app.init(app);

    $html.classList.add(CSS_CLASS.LOADED, CSS_CLASS.READY);
    // is-loading retiré dans Load.finishLoader() une fois le hero préparé

    // Tracking clics services
    document.addEventListener('click', function (e) {
        var link = e.target.closest('a[href*="?service="]');
        if (link && !link.dataset.tracked) {
            e.preventDefault();
            e.stopPropagation();
            var url = link.getAttribute('href');
            var match = url.match(/[?&]service=([^&]+)/);
            if (match) {
                var serviceName = decodeURIComponent(match[1].replace(/\+/g, ' '));
                console.log('🎯 Clic service détecté :', serviceName);
                window.dataLayer = window.dataLayer || [];
                window.dataLayer.push({
                    event: 'clic_service',
                    service_name: serviceName
                });
                console.log('✅ dataLayer.push effectué :', serviceName);
            }
            setTimeout(function () {
                link.dataset.tracked = 'true';
                link.click();
                delete link.dataset.tracked;
            }, 300);
        }
    }, true);

    // ── Tracking clic_book_demo ──────────────────────────────────────────────
    document.addEventListener('click', function (e) {
        var el = e.target.closest('[data-book-demo]');
        if (!el || el.dataset.tracked) return;

        var source = el.getAttribute('data-book-demo');
        var isExternal = el.getAttribute('target') === '_blank';

        // Lien interne (hero → page contact) : bloquer la navigation
        if (!isExternal) {
            e.preventDefault();
            e.stopPropagation();
        }

        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
            event: 'clic_book_demo',
            source: source,
            page_path: window.location.pathname
        });

        console.log('clic_book_demo | source:', source, '| externe:', isExternal, '| page:', window.location.pathname);

        // Délai uniquement si navigation interne (même onglet)
        if (!isExternal) {
            setTimeout(function () {
                el.dataset.tracked = 'true';
                el.click();
                delete el.dataset.tracked;
            }, 300);
        }
    }, true);

    // ── Tracking clic_contact_form ─────────────────────────────────────────
    document.addEventListener('click', function (e) {
        var el = e.target.closest('[data-contact-form]');
        if (!el || el.dataset.tracked) return;

        e.preventDefault();
        e.stopPropagation();

        var source = el.getAttribute('data-contact-form');
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
            event: 'clic_contact_form',
            source: source,
            page_path: window.location.pathname
        });
        console.log('clic_contact_form :', source);

        // Même délai que clic_service pour laisser GTM envoyer avant navigation
        setTimeout(function () {
            el.dataset.tracked = 'true';
            el.click();
            delete el.dataset.tracked;
        }, 300);
    }, true);

    /**
     * Debug focus
     */
    // document.addEventListener(
    //     "focusin",
    //     function () {
    //         console.log('focused: ', document.activeElement)
    //     }, true
    // );
}

////////////////
// Execute
////////////////
function bootApp() {
    init();

    const hasLoader = document.querySelector('.o-loading');

    if ($body.classList.contains('error404') || !hasLoader) {
        window.dispatchEvent(new Event('loading-hide'));
    } else {
        window.dispatchEvent(new Event('loading-pct'));
    }
}

if (document.readyState === 'complete') {
    bootApp();
} else {
    window.addEventListener('load', bootApp, { once: true });
}
